module.exports = __webpack_public_path__ + "img/4.983aed6b.jpg";